export const LINK_CUSTOM_RULE = 'https://event-monitor.rio.cloud/#/rules/create';

export const LINK_VEHICLE_DOWNTIME_TEMPLATE =
    'https://event-monitor.rio.cloud/#/rules/create?scope=%28type%3AACCOUNT%29&condition=%28type%3ADRIVING_STATE%2Cstatus%3ASTAND_STILL%29&minimumMatchDuration=1440';

export const LINK_VEHICLE_POSITION_TEMPLATE =
    'https://event-monitor.rio.cloud/#/rules/create?scope=%28type%3AACCOUNT%29&condition=%28type%3AIGNITION%2Cstatus%3AIGNITION_OFF%29&minimumMatchDuration=720';
